import React, { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { EmptyTable } from './EmptyTable';
import { Card, Col, Row, Table } from 'react-bootstrap';
import { DynamicHeader } from './dynamicTable/DynamicHeader';
import { DynamicColumn } from './dynamicTable/DynamicColumn';
import { FaCheck } from 'react-icons/fa';

interface TableCardComponentProps {
  infiniteScrollClassName: string;
  itemList: {
    items: any[];
  };
  fetchMoreData: () => void;
  totalItems: number;
  gridColumns: any[];
  style?: React.CSSProperties;
  selectedItems?: any[] | any | null;
  selecionarTodos?: any;
  selectItem: (
    itemId: number,
    index: number,
    e: React.MouseEvent,
    lastSelected: number,
    setUltimoSelecionado: any,
    itensSelecionados: any[],
    setItensSelecionados: any,
    referenceList: {
      items: any[];
    }
  ) => void;
  editItem?: (e, index) => void;
  toggleSelecionarTodos?: any;
  ultimoSelecionado?: number;
  setUltimoSelecionado?: any;
  setItensSelecionados?: any;
  isRed?: boolean;
  referenceColumn?: string;
  useIndex?: boolean;
  orderable?: boolean;
  order?: any;
  onColumnOrdered?: (column, direction) => void;
  isLoading?: boolean;
  loadParcelas?: (order, nextPage) => void;
}

/**

ListComponent

@param {string} infiniteScrollClassName - Classe para o componente InfiniteScroll.
@param {object} itemList - Os itens da lista - mostradas na tela.
@param {function} fetchMoreData - Função para buscar mais dados.
@param {number} totalItems - O total de itens.
@param {array} gridColumns - As colunas da tabela.
@param {object} style - OPCIONAL - O estilo do componente.
@param {array|object|null} selectedItems - OPCIONAL - Os itens selecionados (pode ser um array ou um item único).
@param {function} selecionarTodos - OPCIONAL - Função para selecionar todos os itens.
@param {function} selectItem - Função para selecionar um item.
@param {function} editItem - Função para editar um item.
@param {function} toggleSelecionarTodos - OPCIONAL - Função para alternar a seleção de todos os itens.
@param {number} ultimoSelecionado - Classe para o componente InfiniteScroll.

@param {string|null} referenceColumn - OPCIONAL - Coluna usada para poder ser comparada nas funções de seleção.
@param {boolean} useIndex - OPCIONAL - Variável para poder definir se vai usar o index ou não na lógica de seleção dos itens.
@param {boolean} orderable - OPCIONAL - Define se mostrará ou não os ícones para ordenar a tabela
@param {OrderByModel} order - OPCIONAL - objeto contendo informações sobre a ordenação atual
@param {function} onColumnOrdered - OPCIONAL - Função de callback que é executada quando a tabela é ordenada
@param {boolean} isLoading - OPCIONAL - Para o componente saber se ja carregou a tabela inteira ou não

*/

export const TableCardComponent: React.FC<TableCardComponentProps> = ({
  infiniteScrollClassName,
  itemList,
  fetchMoreData,
  totalItems,
  gridColumns,
  selectedItems = null,
  selecionarTodos = null,
  selectItem,
  editItem,
  toggleSelecionarTodos = null,
  ultimoSelecionado = null,
  setUltimoSelecionado = null,
  setItensSelecionados = null,
  isRed = false,
  referenceColumn = null,
  useIndex = false,
  orderable = true,
  order = null,
  onColumnOrdered = null,
  isLoading = true,
  //TODO: ajustar logica para aceitar outras funções de GetList com paginação
  loadParcelas,
}) => {
  const [columnsOrderChanged, setColumnsOrderChanged] = useState(0);

  const isSelected = (i, index) => {
    if (!useIndex) {
      if (Array.isArray(selectedItems)) {
        return selectedItems.some((item) => item[referenceColumn] === i[referenceColumn]);
      } else {
        return i[referenceColumn] === selectedItems;
      }
    } else if (!Array.isArray(selectedItems)) {
      return index === selectedItems;
    }
  };

  useEffect(() => {
    setColumnsOrderChanged(columnsOrderChanged + 1);
  }, [order]);

  useEffect(() => {
    const checkSize = async () => {
      if (!isLoading) {
        var infiniteScrollComponent = document.querySelector(
          '.infinite-scroll-component.height-definition-timesheet'
        );
        var tableElement = document.querySelector(
          '.table.table-sm.table-striped.table-bordered.table-hover'
        );

        if (infiniteScrollComponent && tableElement) {
          var infiniteScrollHeight = infiniteScrollComponent.clientHeight;
          var tableHeight = tableElement.clientHeight;

          if (infiniteScrollHeight > tableHeight && itemList.items?.length < totalItems)
            await loadParcelas(null, true);
        }
      }
    };

    checkSize();
  }, [fetchMoreData]);

  return (
    <>
      <InfiniteScroll
        key={columnsOrderChanged}
        className={infiniteScrollClassName}
        dataLength={itemList.items?.length || 0}
        next={fetchMoreData}
        hasMore={itemList.items?.length < totalItems}
        loader={<b>Carregando...</b>}
        height="100%"
      >
        {itemList.items?.length > 0 ? (
          itemList.items.map((item, idx) => (
            <Card
              key={idx}
              className="mb-2"
              style={{fontSize:13}}
            >
              <Card.Header  >
                <Row>
                  {gridColumns.map((column) => {
                    if (column.showGrid && !column.header.toLowerCase().includes('descri')) {
                      const header = column.header
                        .replace(/^DtMovimentacao$/i, 'Data Movimentação')
                        .replace(/^ProcessoNumero$/i, 'Nº Processo');
                      const value = column.id.match(/^DtMovimentacao$/i)
                        ? (item[column.id] ? new Date(item[column.id]).toLocaleDateString('pt-BR') : '')
                        : item[column.id];
                      return <Col md={6}><Card.Title>{header}: {value}</Card.Title></Col>
                    }
                  })}
                </Row>
              </Card.Header>
              <Card.Body style={{maxHeight: 400, overflowY: 'auto'}}>
              {gridColumns.map((column) => {
                if (column.showGrid && column.header.toLowerCase().includes('descri'))
                  return <Card.Text>{item[column.id]}</Card.Text>
              })}
            </Card.Body>
            </Card>
      ))
      ) : (
      <EmptyTable />
        )}
    </InfiniteScroll >
    </>
  );
};
